import images from "./BodyImages"

// Shu yerga keldim
// Sur'atlar va mahsulotlarni ko'paytirishim kerak
// Body qismdagi barcha surat va text'larni responsive qilishim kerak


const ProductData = [
  {
    category: "televisions",
    items: [
      {
        price: {
          oldPrice: 10000,
          newPrice: 50,
        },
        title: "LG Television",
        comments: 3,
        images: images,
        variantPrices: [
          { price: 10, duration: "5 months" },
        ],
        isFavorite: false,
        rating: 3,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 5000,
          newPrice: 40,
        },
        title: "Samsung Television",
        comments: 5,
        images: images,
        variantPrices: [
          { price: 20, duration: "8 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "televisions" category
      {
        price: {
          oldPrice: 8000,
          newPrice: 55,
        },
        title: "Sony TV",
        comments: 2,
        images: images,
        variantPrices: [
          { price: 15, duration: "6 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "televisions" category
      // ...
    ],
  },
  {
    category: "phones",
    items: [
      {
        price: {
          oldPrice: 999,
          newPrice: 33,
        },
        title: "iPhone",
        comments: 3,
        images: images,
        variantPrices: [
          { price: 15, duration: "6 months" },
        ],
        isFavorite: false,
        rating: 2,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 799,
          newPrice: 30,
        },
        title: "Samsung Galaxy",
        comments: 4,
        images: images,
        variantPrices: [
          { price: 25, duration: "5 months" },
        ],
        isFavorite: false,
        rating: 3,
        cartCount: 0,
      },
      // Add more items within the "phones" category
      {
        price: {
          oldPrice: 899,
          newPrice: 25,
        },
        title: "Google Pixel",
        comments: 2,
        images: images,
        variantPrices: [
          { price: 20, duration: "4 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "phones" category
      // ...
    ],
  },
  {
    category: "laptops",
    items: [
      {
        price: {
          oldPrice: 1500,
          newPrice: 1200,
        },
        title: "Apple MacBook Pro",
        comments: 8,
        images: images,
        variantPrices: [
          { price: 100, duration: "12 months" },
        ],
        isFavorite: false,
        rating: 5,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 1000,
          newPrice: 800,
        },
        title: "Dell XPS 15",
        comments: 6,
        images: images,
        variantPrices: [
          { price: 80, duration: "10 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "laptops" category
      {
        price: {
          oldPrice: 1300,
          newPrice: 1000,
        },
        title: "HP Spectre x360",
        comments: 5,
        images: images,
        variantPrices: [
          { price: 90, duration: "9 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "laptops" category
      // ...
    ],
  },
  {
    category: "watches",
    items: [
      {
        price: {
          oldPrice: 500,
          newPrice: 250,
        },
        title: "Rolex Submariner",
        comments: 10,
        images: images,
        variantPrices: [
          { price: 50, duration: "5 months" },
        ],
        isFavorite: false,
        rating: 5,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 300,
          newPrice: 150,
        },
        title: "Omega Speedmaster",
        comments: 7,
        images: images,
        variantPrices: [
          { price: 30, duration: "3 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      // Add more items within the "watches" category
      {
        price: {
          oldPrice: 200,
          newPrice: 100,
        },
        title: "Seiko Presage",
        comments: 5,
        images: images,
        variantPrices: [
          { price: 20, duration: "2 months" },
        ],
        isFavorite: false,
        rating: 3,
        cartCount: 0,
      },
      // Add more items within the "watches" category
      // ...
    ],
  },
  // Add more categories and items as needed
  // ...

  {
    category: "clothing",
    items: [
      {
        price: {
          oldPrice: 100,
          newPrice: 80,
        },
        title: "Men's T-Shirt",
        comments: 5,
        images: images,
        variantPrices: [
          { price: 70, duration: "3 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 80,
          newPrice: 60,
        },
        title: "Women's Dress",
        comments: 3,
        images: images,
        variantPrices: [
          { price: 50, duration: "2 months" },
        ],
        isFavorite: false,
        rating: 3,
        cartCount: 0,
      },
      {
        price: {
          oldPrice: 120,
          newPrice: 100,
        },
        title: "Unisex Hoodie",
        comments: 2,
        images: images,
        variantPrices: [
          { price: 90, duration: "4 months" },
        ],
        isFavorite: false,
        rating: 4,
        cartCount: 0,
      },
    ],
  },
];

export default ProductData;
